/**
 * @generated SignedSource<<76e1edd0b7a4de32cae5feac7e64c47b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedItems_itemSearch$data = {
  readonly relatedItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly serviceId: string | null;
        readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_item" | "SbSharedThinBrowseItemTrackingProvider_items" | "freeShippingHelpers_item">;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_itemSearch" | "SbSharedThinBrowseItemTrackingProvider_itemSearch">;
  readonly " $fragmentType": "SbSharedRelatedItems_itemSearch";
};
export type SbSharedRelatedItems_itemSearch$key = {
  readonly " $data"?: SbSharedRelatedItems_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedItems_itemSearch">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedItems_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_itemSearch"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedThinBrowseItemTrackingProvider_itemSearch"
    },
    {
      "alias": "relatedItems",
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 12
        },
        {
          "kind": "Literal",
          "name": "seller",
          "value": "INCLUDE"
        }
      ],
      "concreteType": "itemSearchMoreLikeThisConnection",
      "kind": "LinkedField",
      "name": "thinBrowseRelatedItems",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "itemSearchMoreLikeThisEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Item",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SharedItemTile_item"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "SbSharedThinBrowseItemTrackingProvider_items"
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "freeShippingHelpers_item",
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "vertical",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ShipmentQuote",
                      "kind": "LinkedField",
                      "name": "shipmentQuotes",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "isComplimentary",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "FinancialAmount",
                          "kind": "LinkedField",
                          "name": "totalAmount",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "amount",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ShipmentServiceMethod",
                          "kind": "LinkedField",
                          "name": "serviceMethod",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Region",
                              "kind": "LinkedField",
                              "name": "region",
                              "plural": false,
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "regionName",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ]
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "thinBrowseRelatedItems(first:12,seller:\"INCLUDE\")"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};

(node as any).hash = "9258afcb9cdb7b33348a3b099336b016";

export default node;
